//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            blankShow:false,
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            list:[],
            where:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
            grade:0,
            isActive:0,
            uid:0,
            otherId:0,
            types:[],
        }
    },
    mounted(){
        this.uid = this.parseRouteId(this.$route.params.uid);
        this.otherId = this.parseRouteId(this.$route.params.otherId);
        this.grade = this.$func.getLocal('grade');
        this.grade = parseInt(this.grade);
        if(this.grade == 3 || this.grade == 5){
            this.types = [
                {
                    'key':0,
                    'text':'社区收益',
                },
                {
                    'key':1,
                    'text':'分销收益',
                },
                {
                    'key':2,
                    'text':'其他收益',
                },
            ];
        }
    },
    methods: {
        parseRouteId(value){
            let id = parseInt(value);
            return isNaN(id) ? 0 : id;
        },
        select(i){
            // this.where = [];
            this.isActive = i;
            this.lastId = 0;
            this.pageFlag = 2;
            this.list = [];
            this.loadmore();
        },
        getList(){
            this.$api.orderRebate({last_id:this.lastId,page_flag:this.pageFlag,type:this.isActive,uid:this.uid,otherId:this.otherId}).then((res)=>{
                if(res){
                    if(!this.lastId){
                        this.blankShow = res.data.length > 0 ? false : true;
                    }
                    this.hasNext = res.hasNext;
                    this.lastId = res.lastId;
                    res.data.forEach((item)=>{
                        this.list.push(item);
                    });
                }
            })  
        },
        loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            this.getList();
            setTimeout(()=>{
                if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/rebate.vue